import type { LayoutSection } from '../../types/LayoutConfig';
import { isValidLayoutSection } from '../../types/LayoutConfig';

export function parseSection(path: string | undefined): LayoutSection | undefined {
  if (path == null) {
    return;
  }
  const normalized = path.startsWith('/') ? path.slice(1) : path;
  return isValidLayoutSection(normalized) ? normalized : undefined;
}
